function ArrowIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.06 16.64l5.29-5.29-1.41-1.42-5.29 5.3a2 2 0 000 2.82l5.29 5.3 1.41-1.42-5.29-5.29z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default ArrowIcon;
